module.exports = __webpack_public_path__ + "img/add-image18.4f78cfb6.png";